import React, { useState, useEffect } from 'react';
import Card from '../../../../component/Card';
import Form from '../../../../component/Form';
// import withReference from '../../../../../../hoc/withReference';
import { withFormik } from 'formik';
// import moment from 'moment';
// import useDataRequesting from '../../../../../../hooks/useDataRequesting';
// import { getPersyaratan } from '../../../../../DataProvider';
import Service from '../../../../../apiService';

const FormPersyaratan = ({
  existingPersyaratan = null,
  refId,
  isShow,
  data,
  disabled,
  values,
  handleChange,
  handleBlur,
  setFieldValue,
  handleSubmit,
  errors,
  touched,
  sideTitleElement,
}) => {
  const [persyaratan, setPersyaratan] = useState('');
  const getPersyaratan = async (refId) => {
    try {
      const responses = await Service.get(
        `/department/persyaratan/find/${refId}`
      );
      if (responses) {
        setPersyaratan(responses.data);
      }
    } catch (error) {
      return [];
    }
  };

  const openFile = (url) => {
    const win = window.open(url, '_blank');
    if (!win) {
      win.focus();
    }
  };

  useEffect(() => {
    if (!existingPersyaratan) getPersyaratan(refId);
    else setPersyaratan(existingPersyaratan);
  }, []);

  useEffect(() => {
    persyaratan &&
      persyaratan.forEach((syarat) =>
        setFieldValue(`file_${syarat.id}`, {
          file: '',
          validation: '',
          id: syarat.id,
        })
      );
  }, [persyaratan]);
  

  return (
    isShow && (
      <>
        <h1 className='d-inline'>Persyaratan Administrasi</h1>
        {sideTitleElement}
        {persyaratan ? (
          <>
            <Form.Row>
              <Form.Column>
                {persyaratan.map((syarat, i) => {
                  return (
                    <>
                      <Form.FileBrowser
                        label={
                          <>
                            {syarat.name}{' '}
                            <span className='text-red small'>
                              {' '}
                              *{syarat.extension}
                            </span>
                          </>
                        }
                        onChange={(e) => {
                          setFieldValue(`file_${syarat.id}`, {
                            file: e.target.files[0],
                            validation: {
                              extension: syarat.extension,
                              maxSize: syarat.max_size,
                            },
                            id: syarat.id,
                            keterangan: syarat.name,
                          });
                        }}
                        name={`file_${syarat.id}`}
                        fileNameProps={values[`file_${syarat.id}`] && values[`file_${syarat.id}`].file.name}
                        downloadFile={
                          syarat.upload && (
                            <div className='col-lg'>
                              <span
                                onClick={() => openFile(syarat.upload)}
                                className='text-primary text-sm'
                                style={{ cursor: 'pointer' }}>
                                Lihat file terunggah
                              </span>
                            </div>
                          )
                        }
                        validationAlert={
                          errors[`file_${syarat.id}`] &&
                          touched[`file_${syarat.id}`] && (
                            <div id='feedback'>
                              {errors[`file_${syarat.id}`]}
                            </div>
                          )
                        }
                        disabled={disabled}
                      />
                    </>
                  );
                })}
              </Form.Column>
            </Form.Row>
          </>
        ) : (
          ''
        )}
        <Form.Row>
          <Form.Column lg={12} md={12}>
            <button
              className='btn btn-primary float-right'
              onClick={handleSubmit}
              disabled={disabled}>
              Simpan
            </button>
          </Form.Column>
        </Form.Row>
      </>
    )
  );
};

export default withFormik({
  mapPropsToValues: () => ({}),
  validateOnBlur: false,
  validate: (values) => {
    const errors = {};
    const keys = Object.keys(values).filter(
      (key) => key.split('_')[0] === 'file'
    );

    keys.forEach((key) => {
      if (!values[key].file) {
        errors[key] = 'harus diisi';
      } else {
        const extensions = values[key].validation.extension
          .split(',')
          .map((validate) => validate);
        const arrFileName = values[key].file.name.split('.');
        const fileExtension = arrFileName[arrFileName.length - 1].toLowerCase();

        if (!extensions.includes(fileExtension)) {
          errors[
            key
          ] = `extensi file harus ${values[key].validation.extension}`;
        }
        if (values[key].file.size > values[key].validation.maxSize) {
          errors[key] = `ukuran file melebihi ${
            values[key].validation.maxSize / 1024
          } KB`;
        }
      }
    });

    return errors;
  },

  handleSubmit: async (values, { setStatus, props }) => {
    const params = await props.mapValuesToPostParams(
      values,
      props.idPendaftaran
    );
    try {
      const response = await Service.post(props.postUrl, params);
      // setStatus(response);
      if (response) props.onAfterPost();
    } catch (error) {
      console.log(error);
    }
  },
})(FormPersyaratan);
